import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {IsrcsService}
 */
export default class IsrcsService{

    constructor() {
        this.resource = "/isrcs"
        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    get_all(item){
        var parameters = new URLSearchParams(item);
       
        parameters = parameters.toString();
        if(parameters){
            parameters = "?"+parameters;
        }
        return this.http.get(`/all${parameters}`);
    }

    get_one(isrc_id){
        return this.http.get(`/${isrc_id}`)    
    }


}